module.exports = __webpack_public_path__ + "img/Rutschfläche.eb6418e7.svg";